import { ReactNode } from 'react';
import { GridDashboardItem } from '../../types/insight-custom-dashboard';
import IconButton from '@g17eco/molecules/button/IconButton';
import { SimpleTooltip } from '@g17eco/molecules/simple-tooltip';
import { getDisableTooltip } from './gridItemUtils';

export interface EditingWrapperProps {
  children: ReactNode;
  item: GridDashboardItem;
  onItemRemove?: (item: GridDashboardItem) => void;
  handleClickEdit?: (item: GridDashboardItem) => void;
  handleClickDuplicate?: (item: GridDashboardItem) => void;
}

export const EditingWrapper = ({
  children,
  item,
  onItemRemove,
  handleClickEdit,
  handleClickDuplicate,
}: EditingWrapperProps) => {
  const isDuplicateDisabled = item.config?.duplicateDisabled ?? item.config?.deleteDisabled;
  return (
    <div className='position-relative w-100 h-100 grid-item__editing-wrapper border-dash'>
      <div className='position-absolute shadow-sm rounded background-ThemeBgExtralight editing-action-buttons'>
        {handleClickEdit ? (
          <SimpleTooltip text={item.config?.editDisabled ? getDisableTooltip('edited') : ''}>
            <IconButton
              outline={false}
              color='transparent'
              icon='fa-light fa-pencil text-ThemeIconPrimary'
              onClick={() => handleClickEdit(item)}
              disabled={item.config?.editDisabled}
            />
          </SimpleTooltip>
        ) : null}
        <SimpleTooltip text={isDuplicateDisabled ? getDisableTooltip('duplicated') : ''}>
          <IconButton
            outline={false}
            color='transparent'
            icon='fa-light fa-copy text-ThemeWarningMedium'
            onClick={() => handleClickDuplicate?.(item)}
            disabled={isDuplicateDisabled}
          />
        </SimpleTooltip>
        <SimpleTooltip text={item.config?.deleteDisabled ? getDisableTooltip('deleted') : ''}>
          <IconButton
            outline={false}
            color='transparent'
            icon='fa-light fa-trash-can text-ThemeDangerMedium'
            onClick={() => onItemRemove?.(item)}
            disabled={item.config?.deleteDisabled}
          />
        </SimpleTooltip>
      </div>
      {children}
    </div>
  );
};
